module.exports = __webpack_public_path__ + "media/home/Brush_Orange-85cdd5d5.png";